import React, { useEffect, Children } from 'react';
import { Header } from '../components/Header';
import { CustomVideoPlayer } from '../components/CustomVideoPlayer';
import { VideoPlayer } from '../components/VideoPlayer';
import { HeroHighlight, Highlight } from '../components/ui/HeroHighlight';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, CheckCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function CompletionPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.1,
        duration: 0.4
      }
    }
  };
  const itemVariants = {
    hidden: {
      y: 20,
      opacity: 0
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        damping: 12,
        stiffness: 100,
        duration: 0.4
      }
    }
  };
  return <div className="w-full h-screen overflow-hidden" data-id="element-161">
      <HeroHighlight data-id="element-162">
        <div className="h-screen flex flex-col" data-id="element-163">
          <Header data-id="element-164" />
          <motion.main className="flex-1 flex flex-col justify-center max-w-5xl mx-auto px-4 w-full" initial="hidden" animate="visible" variants={containerVariants} data-id="element-165">
            <motion.div variants={itemVariants} data-id="element-166">
              <div className="flex justify-center mb-2 sm:mb-3 items-center" data-id="element-167">
                <div className="flex items-center" data-id="element-168">
                  <motion.button onClick={() => navigate('/indeed')} className="mr-2 h-7 w-7 sm:h-8 sm:w-8 flex items-center justify-center rounded-full bg-white/5 backdrop-blur-sm border border-white/10 text-white hover:bg-white/10 transition-colors" whileHover={{
                  scale: 1.05
                }} whileTap={{
                  scale: 0.95
                }} data-id="element-169">
                    <ChevronLeftIcon className="w-4 h-4" data-id="element-170" />
                  </motion.button>
                  <div className="inline-flex items-center px-3 sm:px-5 py-1 sm:py-1.5 rounded-full border border-white/30 bg-black/30 backdrop-blur-sm" data-id="element-171">
                    <span className="text-xs sm:text-sm font-medium text-white" data-id="element-172">
                      You're done!
                    </span>
                  </div>
                </div>
              </div>
              <h1 className="text-center text-lg sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-2 sm:mb-3 max-w-3xl mx-auto leading-[1.3] text-white" data-id="element-173">
                Congratulations on completing your HIRE Onboarding!
              </h1>

              <div className="relative max-w-3xl mx-auto w-full" data-id="element-174">
                <VideoPlayer mediaId="qbccjvv9s2" data-id="element-175" />
                <motion.button onClick={() => window.open('https://thehireadvantage.co', '_blank')} className="hidden md:flex flex-col items-center gap-1 px-3 py-4 rounded-xl bg-[#7fe0c3]/20 border border-[#7fe0c3]/40 text-[#7fe0c3] hover:bg-[#7fe0c3]/30 transition-colors cursor-pointer absolute -right-16" style={{
                top: '50%',
                y: '-50%'
              }} whileHover={{
                scale: 1.05,
                x: 4
              }} whileTap={{
                scale: 0.95
              }} data-id="element-176">
                  <CheckCircleIcon className="w-6 h-6" data-id="element-177" />
                  <span className="text-xs font-semibold whitespace-nowrap" data-id="element-178">
                    Finish
                  </span>
                </motion.button>
              </div>
              <motion.button onClick={() => window.open('https://thehireadvantage.co', '_blank')} className="md:hidden flex items-center justify-center gap-2 mx-auto mt-3 py-2.5 px-6 rounded-xl bg-[#7fe0c3]/20 border border-[#7fe0c3]/40 text-[#7fe0c3] hover:bg-[#7fe0c3]/30 transition-colors cursor-pointer" whileTap={{
              scale: 0.95
            }} data-id="element-179">
                <span className="text-sm font-semibold" data-id="element-180">Finish</span>
                <CheckCircleIcon className="w-5 h-5" data-id="element-181" />
              </motion.button>
            </motion.div>

            <motion.div className="mt-8 mb-12" variants={itemVariants} data-id="element-182">
              <p className="text-center text-lg sm:text-xl font-medium text-white/80 italic" data-id="element-183">
                Sign off from one of our Founders - Peter Swenson
              </p>
            </motion.div>
          </motion.main>
        </div>
      </HeroHighlight>
    </div>;
}